// Visitor and Action Logging Utility
import axios from 'axios';

// Get API base URL from config
const getApiBaseUrl = () => {
  return process.env.NODE_ENV === 'production' 
    ? 'https://valuacionesya.com:8099' 
    : 'http://localhost:8099';
};

// Generate a session ID for tracking user sessions
const getSessionId = () => {
  let sessionId = localStorage.getItem('visitor_session_id');
  if (!sessionId) {
    sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('visitor_session_id', sessionId);
  }
  return sessionId;
};

// Get visitor information
const getVisitorInfo = () => {
  return {
    userAgent: navigator.userAgent,
    language: navigator.language || navigator.userLanguage,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    referrer: document.referrer,
    url: window.location.href,
    sessionId: getSessionId(),
    timestamp: new Date().toISOString()
  };
};

// Log page visit
export const logPageVisit = async (pageName) => {
  try {
    const apiBaseUrl = getApiBaseUrl();
    const visitData = {
      page: pageName,
      ...getVisitorInfo()
    };

    
    await axios.post(`${apiBaseUrl}/api/log_visit`, visitData);
  } catch (error) {
    // Don't throw error - logging should not break the app
  }
};

// Log user action
export const logUserAction = async (action, details = {}, smp = null) => {
  try {
    const apiBaseUrl = getApiBaseUrl();
    const actionData = {
      action,
      details,
      smp,
      sessionId: getSessionId(),
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    };

    
    await axios.post(`${apiBaseUrl}/api/log_action`, actionData);
  } catch (error) {
    // Don't throw error - logging should not break the app
  }
};

// Predefined action types for consistency
export const ACTIONS = {
  PAGE_VISIT: 'page_visit',
  SMP_SEARCH: 'smp_search',
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_COMPLETED: 'payment_completed',
  ANALYSIS_COMPLETED: 'analysis_completed',
  ERROR_OCCURRED: 'error_occurred',
  BUTTON_CLICKED: 'button_clicked',
  FORM_SUBMITTED: 'form_submitted',
  MODAL_OPENED: 'modal_opened',
  MODAL_CLOSED: 'modal_closed',
  NEW_ANALYSIS_STARTED: 'new_analysis_started'
};

// Quick logging functions for common actions
export const logSMPSearch = (smp) => logUserAction(ACTIONS.SMP_SEARCH, { smp }, smp);
export const logPaymentInitiated = (smp, amount) => logUserAction(ACTIONS.PAYMENT_INITIATED, { smp, amount }, smp);
export const logAnalysisCompleted = (smp) => logUserAction(ACTIONS.ANALYSIS_COMPLETED, { smp }, smp);
export const logError = (errorMessage, context = {}) => logUserAction(ACTIONS.ERROR_OCCURRED, { errorMessage, context });

export default {
  logPageVisit,
  logUserAction,
  logSMPSearch,
  logPaymentInitiated,
  logAnalysisCompleted,
  logError,
  ACTIONS
};
